/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";

import {
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
} from "@mui/material";

import { Menu as MenuIcon } from "@mui/icons-material";

import { NavbarNotificationsDropdown } from "./NavbarNotificationsDropdown";
import { NavbarMessagesDropdown } from "./NavbarMessagesDropdown";
import { NavbarUserDropdown } from "./NavbarUserDropdown";
import { NavbarSearch } from "./NavbarSearch";
import { MiraTheme } from "../../theme/theme";
import { DataProject } from "../../../../api/dataprojects";

const AppBar = styled(MuiAppBar)<{ theme?: MiraTheme }>`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

type NavbarProps = {
  onDrawerToggle: React.MouseEventHandler<HTMLElement>;
  dataProjects?: DataProject[];
  selectedSystemId?: number;
};

const Navbar: React.FC<NavbarProps> = ({
  onDrawerToggle,
  dataProjects,
  selectedSystemId,
}) => {
  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={1}>
        <Toolbar>
          <Grid container alignItems="center" style={{ width: "100%" }}>
            <Grid sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid size={"grow"}>
              <NavbarSearch
                dataProjects={dataProjects}
                selectedSystemId={selectedSystemId}
              />
            </Grid>

            <Grid>
              <NavbarUserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default withTheme(Navbar);
